var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.pixels),function(i){return _c('Pixel',{key:i.key,attrs:{"src":i.src}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }